<xux-input-select
  [field]="field"
  [defaultSelectOptions]="selectOptions$"
  [shouldShowDropdown]="false"
  (selectClick)="selectClickHandler()"
></xux-input-select>
